import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const GlobalSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 25}
    height={props.height ? props.height : 24}
    fill="none"
    {...props}
  >
    <path
      stroke="#F5F6F7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M12.86 22.5c5.798 0 10.5-4.701 10.5-10.5S18.657 1.5 12.86 1.5c-5.8 0-10.5 4.701-10.5 10.5s4.7 10.5 10.5 10.5Z"
    />
    <path
      stroke="#F5F6F7"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M2.36 9.322C5.064 8.659 8.77 8.25 12.86 8.25c4.088 0 7.794.409 10.5 1.072m-21 5.356c2.705.663 6.411 1.072 10.5 1.072 4.088 0 7.794-.409 10.5-1.072"
    />
    <path
      stroke="#F5F6F7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M12.86 1.5c.228 0 .564.1 1 .521.444.43.912 1.122 1.338 2.095.849 1.94 1.411 4.727 1.411 7.884s-.562 5.943-1.412 7.884c-.425.973-.893 1.666-1.337 2.095-.436.421-.772.521-1 .521-.23 0-.565-.1-1.002-.521-.443-.43-.911-1.122-1.337-2.095C9.672 17.944 9.11 15.157 9.11 12s.563-5.943 1.412-7.884c.426-.973.894-1.666 1.337-2.095.437-.421.773-.521 1.001-.521Z"
    />
  </svg>
)
export default GlobalSVG
